import { useContext } from 'react';
import { DrawerContext } from '@context';

export const useDrawerContext = () => {
  const context = useContext(DrawerContext);
  return context;
};
